import type { ViewMode } from '@features/appointments';

import {
  bucketClusterize,
  bucketClusterizeByResource,
  type ClusteredCalendarEvent,
  sideBySideLanesLayout,
} from './clusterDensity';
import { denseOverlapLayout } from './denseOverlapLayout';
import type { CalendarEvent } from './types';

export const shouldClusterBusyCalendarHours = (
  viewMode: ViewMode,
  clusterBusyHours: boolean,
): boolean => clusterBusyHours && viewMode === 'week';

export const prepareCalendarAppointmentEvents = ({
  clusterBusyHours,
  dayClusterPassThroughMax,
  events,
  viewMode,
}: {
  clusterBusyHours: boolean;
  dayClusterPassThroughMax: number;
  events: CalendarEvent[];
  viewMode: ViewMode;
}): ClusteredCalendarEvent[] => {
  if (shouldClusterBusyCalendarHours(viewMode, clusterBusyHours)) {
    return bucketClusterize(events);
  }

  if (viewMode === 'day' && Number.isFinite(dayClusterPassThroughMax)) {
    return bucketClusterizeByResource(events, { passThroughMax: dayClusterPassThroughMax });
  }

  return events;
};

export const getCalendarDayLayoutAlgorithm = (viewMode: ViewMode, clusterBusyHours: boolean) => {
  if (shouldClusterBusyCalendarHours(viewMode, clusterBusyHours) || viewMode === 'day') {
    return sideBySideLanesLayout;
  }

  return viewMode === 'month' ? ('no-overlap' as const) : denseOverlapLayout;
};
